import "./header.css";

export default function Header({ onMenuClick }) {
  return (
    <div className="header">

      {/* Hamburger */}
      <div className="menu" onClick={onMenuClick}>☰</div>

      {/* Titles */}
      <h1>Megamind</h1>
      <h2>Abacus Practice</h2>

      {/* Diagonal overlay */}
      {/* <div className="header-overlay"></div> */}

    </div>
  );
}